import Box from './layouts/Box';
import { useTranslation } from 'react-i18next';
import {FC, Fragment} from "react";

interface ErrorsProps {
  errors?: string[]|boolean;
}

const Errors: FC<ErrorsProps> = ({ errors }) => {
  const { t } = useTranslation();

  if (!Array.isArray(errors) || errors.length < 1) {
    return null;
  }

  return (
    <Fragment>
      {errors.map((error) => (
        <Box key={error} color="alert" fontScale="s" mt="xs">
          {t(error)}
        </Box>
      ))}
    </Fragment>
  )
};

Errors.defaultProps = {
  errors: null,
};

export default Errors;
